import React from "react";
import { Label, Checkbox } from "@/components/ui";
import { FileText } from "lucide-react";

/**
 * Transaction Type Filter Component
 *
 * Checkbox filter for transaction types.
 * Requirements: 5.1-5.9
 */
const TransactionTypeFilter = ({ selectedTypes = [], onChange }) => {
  const transactionTypes = [
    { value: "invoice", label: "Invoice" },
    { value: "bill", label: "Bill" },
    { value: "expense", label: "Expense" },
    { value: "project", label: "Project" },
    { value: "payroll", label: "Payroll" },
    { value: "asset", label: "Asset" },
    { value: "manual", label: "Manual" },
  ];

  const handleToggle = (typeValue) => {
    const newSelection = selectedTypes.includes(typeValue)
      ? selectedTypes.filter((t) => t !== typeValue)
      : [...selectedTypes, typeValue];
    onChange(newSelection);
  };

  return (
    <div className="space-y-2">
      <Label className="flex items-center gap-2">
        <FileText className="h-4 w-4" />
        Transaction Types
      </Label>
      <div className="space-y-2">
        {transactionTypes.map((type) => (
          <div key={type.value} className="flex items-center space-x-2">
            <Checkbox
              id={`type-${type.value}`}
              checked={selectedTypes.includes(type.value)}
              onCheckedChange={() => handleToggle(type.value)}
            />
            <label
              htmlFor={`type-${type.value}`}
              className="text-sm cursor-pointer"
            >
              {type.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TransactionTypeFilter;
